<template lang="pug">
    .background--video-container.layer(v-parallax="0.2", ref="videoContainer")
        template(v-for="video in videos")
            transition(name="fade", appear)
                video.background--video(autoplay, muted, playsinline, loop, v-if="video === current && notDraggerOpen")
                    source(:src="`/static/${video}.mp4`", type="video/mp4")
</template>
<script>
export default {
    data() {
        return {
            videos: [
                'home',
                'breathing',
                'feeling',
                'seeing',
                'thinking',
                'tasting',
                'moving',
                'final',
            ],
            // current: this.$route.name.toLowerCase()
        }
    },
    mounted() {
        this.videoSize()
        window.addEventListener('resize', () => {
            this.videoSize()
        }),
        TweenMax.to('.background--video-container', 1, { opacity: 1, ease: Power2.easeOut })
    },
    methods: {
        videoSize() {
            TweenMax.to('.background--video', .1, { width: window.innerWidth + 120, height: window.innerHeight + 120, ease: Power2.easeOut });
        }
    },
    computed: {
        notDraggerOpen() {
            return !this.$store.state.draggerOpen
        },
        current() {
            let route = this.$route.name.toLowerCase()
            this.videoSize()
            return route
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/videos.vue